import { get } from 'core_main/request';
import { addUserToStore } from 'core_main/store';
import { makeUserEndpoint } from './helpers';

export const getUser = (userId: string) => {
  return get(makeUserEndpoint(userId)).then((response) => {
    const { id } = response.data;
    const { attributes } = response.data;

    addUserToStore(id, attributes);

    return response;
  });
};
